export { default as getCurrentPathTab } from './getCurrentPathTab';
